import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheMasterstroke() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: imgRef,
    isVisible: imgVisible
  } = useRevealOnScroll();
  return <section data-section-id="19672" id="reliable-property-transformations" className="relative flex min-h-[90vh] w-full flex-col lg:flex-row dark bg-background text-foreground overflow-hidden">
      {}
      <div ref={imgRef} className={`relative h-[50vh] w-full lg:h-auto lg:w-[60%] transition-opacity duration-1000 ease-out ${imgVisible ? "opacity-100" : "opacity-0"}`}>
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1622208/img/luxury_interior_renovation.png)] bg-cover bg-center bg-no-repeat">
          {}
          <div className="absolute inset-0 bg-black/20 lg:bg-transparent" />
        </div>
      </div>

      {}
      <div className="relative flex w-full flex-col justify-center px-6 py-16 lg:w-[40%] lg:px-16 lg:py-0">
        <div ref={textRef} className={`flex flex-col items-start gap-8 transition-all duration-1000 ease-out ${textVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h1 className="font-default text-5xl font-black uppercase leading-[0.95] tracking-tighter text-foreground sm:text-6xl lg:text-7xl">
            WE BUILD. WE REPAIR. <span className="text-primary">WE TRANSFORM.</span>
          </h1>

          <p className="max-w-md text-lg leading-relaxed text-muted-foreground font-sans">
            <span className="block font-mono text-3xl font-bold text-primary mb-6 tracking-tight">954-681-5265</span>
            SMITH & B GROUP LLC delivers architectural precision in drywall, painting, and full-scale renovations. From residential demo to refined finishing, we manage every detail of your transformation.
          </p>

          <div className="flex flex-col gap-5 sm:flex-row sm:items-center">
            <Button asChild size="lg" className="h-14 px-8 text-base shadow-lg bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm font-default uppercase font-bold">
              <Link to="#">Experience Excellence</Link>
            </Button>

            <Link to="#" className="group flex items-center gap-2 text-base font-bold uppercase font-default text-foreground transition-colors hover:text-primary">
              View Our Gallery
              <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}